module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"search":"Buscar...","no-results":"Não foram encontrados resultados.","pagination":{"previous":"Anterior","of":"de","next":"Próximo"}},"en-US":{"search":"Search...","no-results":"No results found.","pagination":{"previous":"Previous","of":"of","next":"Next"}}}')
  delete Component.options._Ctor
}
